import { IHttpResponse } from "app_types/httpTypes"
import { CourseSchedulingModes } from "../courseScheduling/courseSchedulingModeTypes"

export enum CertificateSettingType {
  ATTENDANCE = 'attendance',
  ATTENDANCE_APPROVAL = 'attendance_approval',
}

export const CERTIFICATE_SETTINGS_TYPE_NAME = {
  [CertificateSettingType.ATTENDANCE]: "Asistencia",
  [CertificateSettingType.ATTENDANCE_APPROVAL]: "Asistencia y aprobación"
}

export interface ICertificateSettingItemConfiguration {
  attendance?: boolean
  exam?: boolean
  progress?: boolean
  averageScore?: boolean
}

export const CERTIFICATION_SETTINGS_BY_MODALITY: Partial<Record<CourseSchedulingModes, Record<CertificateSettingType, ICertificateSettingItemConfiguration>>> = {
  [CourseSchedulingModes.ON_SITE_ON_LINE]: {
    [CertificateSettingType.ATTENDANCE]: {
      attendance: true
    },
    [CertificateSettingType.ATTENDANCE_APPROVAL]: {
      attendance: true,
      exam: true
    }
  },
  [CourseSchedulingModes.ON_SITE]: {
    [CertificateSettingType.ATTENDANCE]: {
      attendance: true
    },
    [CertificateSettingType.ATTENDANCE_APPROVAL]: {
      attendance: true,
      exam: true
    }
  },
  [CourseSchedulingModes.ON_LINE]: {
    [CertificateSettingType.ATTENDANCE]: {
      attendance: true
    },
    [CertificateSettingType.ATTENDANCE_APPROVAL]: {
      attendance: true,
      exam: true
    }
  },
  [CourseSchedulingModes.VIRTUAL]: {
    [CertificateSettingType.ATTENDANCE]: {
      progress: true,
      averageScore: true,
    },
    [CertificateSettingType.ATTENDANCE_APPROVAL]: {
      progress: true,
      exam: true,
      averageScore: true,
    }
  }
}

export const getCertificationSettingDefaultAttendance = (): ICertificateSettingsItem => {
  return {
    percentage: 75,
    status: false,
  }
}

export const getCertificationSettingDefaultExam = (): ICertificateSettingsItem => {
  return {
    percentage: 70,
    status: false,
  }
}

export const getCertificationSettingDefaultProgress = (): ICertificateSettingsItem => {
  return {
    percentage: 90,
    status: false,
  }
}

export const getCertificationSettingDefaultAverageScore = (): ICertificateSettingsItem => {
  return {
    percentage: 70,
    status: false,
  }
}

export interface ICertificateSettings {
  _id: string
  certificateName: string
  courseScheduling: string
  duration: number
  certificationType: CertificateSettingType
  metadata: ICertificateSettingsMetadata
  modules: ICertificateSettingsModule[]
}

export interface ICertificateSettingsModule {
  courseSchedulingDetail: string
  exam?: ICertificateSettingsItem
  attendance?: ICertificateSettingsItem
  progress?: ICertificateSettingsItem
  averageScore?: ICertificateSettingsItem
  duration: number
  durationValidation: number
}

export interface ICertificateSettingsItem {
  status: boolean
  percentage: number
}

export interface ICertificateSettingsMetadata {
  createdBy: {
    username: string
    name: string
  }
  lastUpdatedBy: {
    username: string
    name: string
  }
}

export type ICertificateSettingsCreateParams = Omit<ICertificateSettings, '_id' | 'metadata'>

export type ICertificateSettingsUpdateParams = Partial<ICertificateSettingsCreateParams> & {
  id: string
}

export interface ICertificateSettingsListParams {
  pageNumber?:string, // Numero de pagina
  nPerPage?:string, // Cantidad de elementos por pagina
  select?: string, // Campos de la coleccion a buscar
  search?:string, // Busca sobre los campos de la coleccion
  courseScheduling?: string
}

export interface ICertificateSettingsGetByIdParams {
  id: string
}

export interface ICertificateSettingsDeleteParams {
  id: string
}

export interface ICertificatesStudent {
  studentCode: string
  userId: string
  studentName: string
  studentDocnumber: string
  studentUsername: string
  certifications: ICertificateStudentProcessed[],
}

export interface ICertificateStudentProcessed {
  certificateSettingId: string
  certificateName: string
  certificateType: CertificateSettingType
  certificate: ICertificateStudentData
  approved: boolean
  modules: ICertificateStudentModule[]
  isPartial: boolean
}

export interface ICertificateStudentStats {
  validated: number
  total: number
}

export interface ICertificateStudentData {
  isGenerated: boolean
  certificateStatus: string;
  certificateUrl?: string
  certificateDate?: string
  certificateHash?: string
  certificateId: string
  errorMessage?: string
}

export interface ICertificateStudentModule {
  courseSchedulingDetailId: string
  courseSchedulingDetailName: string
  moduleCriteriaResume: ICertificateMultipleDataCertificationModuleCriteriaResume[]
  approved: boolean;
}

export interface ICertificateMultipleDataCertificationModuleCriteriaResume {
  type: ICertificateStudentModule;
  percentageRequired: number;
  percentageObtainer: number;
  approved: boolean;
}

export interface ICertificateMultipleDataParams {
  course_scheduling: string;
  without_certification?: boolean;
  studentId?: string;
}

export interface ICertificateMultipleDataResponse extends IHttpResponse {
  students: ICertificatesStudent[]
  courseSchedulingId: string,
  warnings?: {key: string, message: string}[]
}

export interface ICertificateMultipleByStudentParams {
  course_scheduling: string;
  studentId: string;
  only_certificates?: boolean
}

export interface ICertificateMultipleByStudentResponse extends IHttpResponse {
  student: ICertificatesStudent
  courseSchedulingId: string
}

export interface ICertificateMultipleGenerateParams {
  courseSchedulingId: string
  students: {
    userId: string
    certificateSettings: {certificateSettingId: string, isPartial: boolean}[]
  }[]
}

export interface ICertificateMultipleGenerateResponse extends IHttpResponse {}
